import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SessionService } from '@services/session.service';
import { BaseFuncionalidadComponent } from '@shared/base/base-funcionalidad.component';
import { DangerError, WarningError } from '@shared/errors/custom.error';
import { ExpedienteService } from '@services/expediente.service';
import inicializarDataTable from '@shared/helpers/datatables.helper';
import { ErrorService } from '@services/error.service';
import { ExpedienteHistorial } from '@models/expediente-historial.model';
import { StateService } from '@services/state.service';
import { TerminologiaService } from '@services/terminologia.service';
import { Mensajes } from '@shared/enums/mensajes.enum';
import Roles from '@shared/enums/roles.enum';
import { Archivo } from '@models/archivo.model';

@Component({
    selector: 'app-expedientes-detalle-historial',
    templateUrl: './expedientes-detalle-historial.component.html'
})
export class ExpedientesDetalleHistorialComponent extends BaseFuncionalidadComponent {
    constructor(
        sessionService: SessionService,
        route: ActivatedRoute,
        location: Location,
        router: Router,
        stateService: StateService,
        private expedienteService: ExpedienteService,
        private errorService: ErrorService,
        private terminologiaService: TerminologiaService
    ) {
        super(route, sessionService, location, router, stateService);
    }

    estados: ExpedienteHistorial[] = []; // Variable que guarda la información de las licencias medicas que se muestran en la tabla
    documentos: Archivo[] = []; // Variable que guarda la información de los documentos del expediente

    mensajeSinResultados: string; // Mensaje de respuesta de la BD

    isLoadingDocumento: boolean; // Mensaje para mostrar loading al presionar ver documento

    ngOnInit() {
        this.verHistorial();
    }
      
    get mensajeSinPermisos(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_funcionalidad);
    }

    get mensajeSinPermisosAccion(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_accion);
    }

    get isProveedor() {
        return this.sessionService.rolActual === Roles.prestador;
    }

    async verHistorial() {
        this.isLoading = true;
        try {
          if (!this.canReadHistory) throw new DangerError(this.mensajeSinPermisosAccion);
          if (!this.id) throw new WarningError("Expediente no seleccionado");
          this.estados = await this.expedienteService.obtenerExpedientesEstados(this.id);
          inicializarDataTable("#tabla-estados", [-1]);
        } catch (error) {
          if (error instanceof DangerError) this.mensajeSinResultados = error.message;
          this.errorService.handle(error, "Error al obtener las licencias.");
        } finally {
          this.isLoading = false;
        }
    }
}
